// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__CashboxCartMobile from "./CashboxCartMobile.js";
import * as Buhta_cabinet__CashboxCartPanel from "./CashboxCartPanel.js";
import * as Buhta_cabinet__CashboxCatalog from "./CashboxCatalog.js";
import * as Buhta_cabinet__CashboxForm from "../../../../models/CashboxForm.js";
import * as Buhta_cabinet__CashboxPayment from "./CashboxPayment.js";
import * as Buhta_cabinet__CashboxReceipt from "./CashboxReceipt.js";
import * as Buhta_cabinet__Kassa from "../../../../grpc/Kassa.js";
import * as Buhta_cabinet__Route from "../../../../Route.js";
import * as Buhta_cabinet__Select from "../../../html/Select.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Curry from "melange.js/curry.js";
import * as ReasonReactRouter from "reason-react/ReasonReactRouter.js";
import * as Stdlib from "melange/stdlib.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import CloseSvg from "static/icons/close.svg";

const layout = "h-full w-full t-0 l-0 lg:grid lg:grid-rows-auto-1fr lg:gap-4 bg-gray-pale py-4";

const Styles = {
  layout: layout
};

const operationTypeOptions = {
  hd: {
    value: /* OPERATION_TYPE_SALE */1,
    text: "Продажа"
  },
  tl: {
    hd: {
      value: /* OPERATION_TYPE_SALE_RETURN */2,
      text: "Возврат"
    },
    tl: /* [] */0
  }
};

function make(onCloseOpt) {
  const onClose = onCloseOpt !== undefined ? onCloseOpt : (function (param) {
        
      });
  return function (selectedOperationType) {
    return function (onSelectOperationType) {
      return JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(Buhta_cabinet__Select.make, {
                                options: operationTypeOptions,
                                nowrap: true,
                                size: "m",
                                selectedOption: selectedOperationType,
                                onChange: Curry.__1(onSelectOperationType)
                              }),
                          className: "flex gap-4"
                        }),
                    JsxRuntime.jsx("button", {
                          children: JsxRuntime.jsx(CloseSvg, {}),
                          onClick: (function (param) {
                              Curry._1(onClose, undefined);
                            })
                        })
                  ],
                  className: "flex justify-between px-4 lg:px-6"
                });
    };
  };
}

function CashboxLayout$NavigationBar(Props) {
  return Curry._1(make(Props.onClose)(Props.selectedOperationType), Props.onSelectOperationType);
}

const NavigationBar = {
  make: CashboxLayout$NavigationBar
};

function make$1(org) {
  return function (kkm) {
    const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
    const deviceType = state.deviceType;
    const match = Buhta_core__Tenant.useTenant(undefined);
    const tenant = match[0];
    const currentUrl = Buhta_cabinet__Route.useUrl(undefined);
    const match$1 = React.useState(function () {
          return Belt__Belt_List.head(operationTypeOptions);
        });
    const setSelectedOperationType = match$1[1];
    const selectedOperationType = match$1[0];
    const operation_type = selectedOperationType !== undefined ? selectedOperationType.value : /* OPERATION_TYPE_SALE */1;
    const match$2 = React.useState(function () {
          return /* Catalog */0;
        });
    const setStage = match$2[1];
    const stage = match$2[0];
    const onTransition = function (stage) {
      console.log("transition", stage);
      if (typeof stage !== "number" && stage.TAG !== /* Payment */0) {
        Buhta_cabinet__Route.updateBrowserLocation(Buhta_cabinet__Route.toString(Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, {
                      TAG: /* Kassa */2,
                      _0: /* Kkms */{
                        _0: /* Kkm */{
                          _0: kkm.id,
                          _1: {
                            TAG: /* Receipts */1,
                            _0: {
                              TAG: /* View */0,
                              _0: stage._0.id
                            }
                          }
                        }
                      }
                    })));
      }
      Curry._1(setStage, (function (param) {
              return stage;
            }));
    };
    const onStartOver = function (param) {
      console.log("start over");
      Buhta_cabinet__Route.updateBrowserLocation(Buhta_cabinet__Route.toString(Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, {
                    TAG: /* Kassa */2,
                    _0: /* Kkms */{
                      _0: /* Kkm */{
                        _0: kkm.id,
                        _1: /* Cashbox */4
                      }
                    }
                  })));
      Curry._1(setStage, (function (param) {
              return /* Catalog */0;
            }));
    };
    const onSubmit = function (state) {
      const items = Belt__Belt_List.map(state.items, (function (orig) {
              return Buhta_cabinet__Kassa.ReceiptForm.makeItem(orig.item_type, orig.name, Stdlib.string_of_float(orig.item_price), Stdlib.string_of_float(orig.qty), undefined);
            }));
      const payments = Belt__Belt_List.map(state.payments, (function (orig) {
              return Buhta_cabinet__Kassa.ReceiptForm.makePayment(orig.payment_type, Stdlib.string_of_float(orig.amount), undefined);
            }));
      const form = Buhta_cabinet__Kassa.ReceiptForm.make(operation_type, items, payments, undefined);
      return Buhta_cabinet__Kassa.ReceiptService.create(tenant, kkm.id, form);
    };
    const initialState = function (param) {
      return {
              operation_type: operation_type,
              items: /* [] */0,
              payments: /* [] */0,
              total_amount: 0,
              taken: 0,
              change: 0
            };
    };
    const match$3 = Buhta_cabinet__CashboxForm.useForm(onTransition, onStartOver, onSubmit, initialState);
    const updateForm = match$3[1];
    const form = match$3[0];
    let tmp;
    if (typeof stage === "number") {
      const onItemBeingAdded = function (item) {
        Curry._1(updateForm, {
              TAG: /* AddItem */1,
              _0: item
            });
      };
      tmp = JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(Buhta_cabinet__CashboxCatalog.make, {
                          org: org,
                          onItemBeingAdded: onItemBeingAdded
                        })
                  }),
              deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__CashboxCartMobile.make, {
                      items: form.items,
                      onUpdate: (function (item, index) {
                          Curry._1(updateForm, {
                                TAG: /* UpdateItem */2,
                                _0: item,
                                _1: index
                              });
                        }),
                      onDelete: (function (index) {
                          Curry._1(updateForm, {
                                TAG: /* DeleteItem */3,
                                _0: index
                              });
                        }),
                      onDeleteAll: (function (items) {
                          Curry._1(updateForm, {
                                TAG: /* DeleteAll */4,
                                _0: items
                              });
                        }),
                      onSubmit: (function (param) {
                          Curry._1(updateForm, {
                                TAG: /* TransitionTo */0,
                                _0: {
                                  TAG: /* Payment */0,
                                  _0: /* Filling */0
                                }
                              });
                        })
                    }) : JsxRuntime.jsx(Buhta_cabinet__CashboxCartPanel.make, {
                      items: form.items,
                      onSubmit: (function (param) {
                          Curry._1(updateForm, {
                                TAG: /* TransitionTo */0,
                                _0: {
                                  TAG: /* Payment */0,
                                  _0: /* Filling */0
                                }
                              });
                        }),
                      onUpdate: (function (item, index) {
                          Curry._1(updateForm, {
                                TAG: /* UpdateItem */2,
                                _0: item,
                                _1: index
                              });
                        }),
                      onDelete: (function (index) {
                          Curry._1(updateForm, {
                                TAG: /* DeleteItem */3,
                                _0: index
                              });
                        }),
                      onDeleteAll: (function (items) {
                          Curry._1(updateForm, {
                                TAG: /* DeleteAll */4,
                                _0: items
                              });
                        }),
                      kkm: kkm
                    })
            ],
            className: "lg:grid lg:grid-cols-8-4 gap-4 lg:gap-6 lg:overflow-auto px-4 lg:px-6"
          });
    } else if (stage.TAG === /* Payment */0) {
      tmp = JsxRuntime.jsx(Buhta_cabinet__CashboxPayment.make, {
            org: org,
            form: form,
            updateForm: updateForm,
            stage: stage._0,
            kkm: kkm
          });
    } else {
      const onStartOverClicked = function (param) {
        Curry._1(updateForm, /* StartOver */0);
      };
      tmp = JsxRuntime.jsx(Buhta_cabinet__CashboxReceipt.make, {
            org: org,
            receipt: stage._0,
            onStartOverClicked: onStartOverClicked,
            kkm: kkm
          });
    }
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(CashboxLayout$NavigationBar, {
                        onClose: (function (param) {
                            ReasonReactRouter.push(Belt__Belt_Option.getWithDefault(Buhta_cabinet__Route.getParamValue(currentUrl, "return_to", undefined), "/org/" + (String(org.id) + ("/kassa/kkms/" + String(kkm.id)))));
                          }),
                        selectedOperationType: selectedOperationType,
                        onSelectOperationType: (function (value) {
                            Curry._1(setSelectedOperationType, (function (param) {
                                    return value;
                                  }));
                          })
                      }),
                  tmp
                ],
                className: layout
              });
  };
}

function CashboxLayout(Props) {
  return make$1(Props.org)(Props.kkm);
}

const make$2 = CashboxLayout;

export {
  Styles ,
  operationTypeOptions ,
  NavigationBar ,
  make$2 as make,
}
/* Buhta_cabinet__CashboxCartMobile Not a pure module */
